import { useTranslation } from "react-i18next";
import { kaspreadsheetUrl } from "@/mocks/categories";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20photography%20flat%20lay%20with%20sneakers%20hoodies%20caps%20and%20accessories%20arranged%20on%20a%20creamy%20beige%20textured%20surface%2C%20soft%20diffused%20natural%20lighting%20from%20the%20left%20casting%20gentle%20shadows%2C%20warm%20neutral%20color%20palette%20with%20sage%20green%20accents%2C%20minimal%20clean%20composition%2C%20high%20end%20editorial%20catalog%20style%2C%20sophisticated%20European%20aesthetic&width=1800&height=1200&seq=hero-bg-v2-6a7d3c&orientation=landscape"
          alt="USFansSpreadsheet przewodnik i bezpieczeństwo"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          {t("hero.title")}
        </h1>
        <p className="text-background-100/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-10">
          {t("hero.subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={kaspreadsheetUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            {t("hero.cta_guide")}
            <div className="w-4 h-4 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-up-line text-xs"></i>
            </div>
          </a>
          <a
            href={kaspreadsheetUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center px-8 py-3.5 bg-accent-500 text-primary-800 text-sm md:text-base font-medium rounded-full hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer"
          >
            {t("hero.cta_buy")}
            <div className="w-4 h-4 flex items-center justify-center ml-2">
              <i className="ri-shopping-cart-line text-xs"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}